module.exports = __webpack_public_path__ + "img/symbol_pfeilundbogen@2x.5d6857f.webp";